<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Container',
};
</script>

<style lang="less">
.container {
  width: 100%;
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
}
</style>
